module.exports = __webpack_public_path__ + "static/dino-logo-a870589e884a0a6782d3c1c8ed23852a.png";